import { InjectionToken } from '@angular/core';
import { ShopifyConfig } from '../config/shopify-config.model';

export const SHOPIFY_CONFIG = new InjectionToken<ShopifyConfig>('SHOPIFY_CONFIG');
